import {Select} from '@/components/ui/Select';
import {useId} from 'react';
import type {TeamRole} from '@/types/api';

const ROLES: TeamRole[] = ['Administrator', 'Editor', 'Author', 'Contributor'];

const ROLE_DESCRIPTIONS: Record<TeamRole, string> = {
    Administrator: 'Full access to all publication settings and content',
    Editor: 'Can publish and manage all posts and pages',
    Author: 'Can write and publish their own posts',
    Contributor: 'Can write posts but cannot publish'
};

interface RoleSelectorProps {
    value: TeamRole;
    onChange: (role: TeamRole) => void;
    disabled?: boolean;
    showLabel?: boolean;
}

export function RoleSelector({value, onChange, disabled, showLabel = true}: RoleSelectorProps) {
    const id = useId();
    const options = ROLES.map(role => ({
        value: role,
        label: role
    }));

    return (
        <div style={{display: 'flex', flexDirection: 'column', gap: 8}}>
            {showLabel && (
                <label
                    htmlFor={id}
                    style={{
                        fontSize: '1.3rem',
                        fontWeight: 600,
                        color: 'var(--tt-text-primary)'
                    }}
                >
                    Role
                </label>
            )}
            <Select
                ariaLabel={showLabel ? undefined : 'Role'}
                disabled={disabled}
                id={id}
                options={options}
                value={value}
                width="100%"
                onChange={val => onChange(val as TeamRole)}
            />
            <p
                style={{
                    fontSize: '1.2rem',
                    color: 'var(--tt-text-secondary)',
                    margin: 0
                }}
            >
                {ROLE_DESCRIPTIONS[value]}
            </p>
        </div>
    );
}
